import "./TFDAccelerateAcademy.css";

import { Link } from "react-router-dom";
import React from "react";

export default function TFDAccelerateAcademy() {
  return (
    <div className="tfd-accelerate-academy-page">
      {/* HERO / BANNER SECTION */}
      <section className="tf-hero-academy">
        <div className="hero-image-wrap">
          <img
            src="/images/accelerate/accelerate-hero.jpg"
            alt="TFD Accelerate Hero"
            className="hero-bg-image"
          />
          <div className="overlay-dark" />
        </div>
        <div className="hero-content themeflat-container">
          <h1 className="hero-title wow fadeInUp animated">
            TFD ACCELERATE – Academy
          </h1>
          <p className="hero-subtitle wow fadeInUp animated">
            Empower your child to thrive with advanced training.
          </p>
          <Link to="/contact" className="flat-button wow fadeInUp animated">
            Join Accelerate
          </Link>
        </div>
      </section>

      {/* MAIN INFO SECTION */}
      <section className="tf-academy-info main-content">
        <div className="themeflat-container">
          <div className="row align-items-center">
            <div className="col-md-6 info-text wow fadeInLeft animated">
              <div className="title-box title-small-v2">
                <span className="sub-title">Why TFD Accelerate?</span>
                <h2 className="title-section">
                  Take Your Skills to the Next Level
                </h2>
              </div>
              <p className="post">
                Our Accelerate program gives players the tools, support, and
                personalized training needed to become confident both on and
                off the pitch. Experience advanced development, resilience
                building, and unmatched competitive preparation.
              </p>
              <Link to="/contact" className="flat-button">
                Start Accelerating
              </Link>
            </div>
            <div className="col-md-6 info-image wow fadeInRight animated">
              <div className="image-wraper">
                <img
                  src="/images/accelerate/accelerate-info.jpg"
                  alt="Accelerate Training Session"
                  className="image-gr"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BENEFITS SECTION */}
      <section className="tf-benefits main-content">
        <div className="themeflat-container">
          <div className="title-box center-title-box title-large">
            <h2 className="title-section wow fadeInUp animated">
              Why Choose TFD Accelerate?
            </h2>
          </div>
          <div className="row benefits-row">
            <div className="col-md-6 benefit-item wow fadeInLeft animated">
              <h4 className="title-benefit">Expert Coaching</h4>
              <p className="description-benefit">
                Our elite coaching team provides personalized attention and the
                latest training techniques.
              </p>
            </div>
            <div className="col-md-6 benefit-item wow fadeInRight animated">
              <h4 className="title-benefit">Tailored Programs</h4>
              <p className="description-benefit">
                Customized sessions designed to suit each player’s strengths and
                goals.
              </p>
            </div>
            <div className="col-md-6 benefit-item wow fadeInLeft animated">
              <h4 className="title-benefit">Holistic Development</h4>
              <p className="description-benefit">
                Focusing on technical, tactical, and mental growth for complete
                player development.
              </p>
            </div>
            <div className="col-md-6 benefit-item wow fadeInRight animated">
              <h4 className="title-benefit">Pathways to Success</h4>
              <p className="description-benefit">
                Opening doors to club trials, school teams, and elite competitions.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CALL-TO-ACTION SECTION */}
      <section className="tf-cta main-content">
        <div className="themeflat-container text-center">
          <Link
            to="/contact"
            className="flat-button big-cta-button wow fadeInUp animated"
          >
            Enroll in TFD Accelerate Academy
          </Link>
        </div>
      </section>
    </div>
  );
}
